import { Moment } from "moment";

export type Term = {
  isPast: boolean;
  isToday: boolean;
  isFuture: boolean;
  today?: Moment;
  current?: Moment;
};
